import * as React from "react";

import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";



export default function PageContent({content}) {

  return (
      <Box
        id="f"
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[800],
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Toolbar id="g" />
        <Container id="h" maxWidth="xl" sx={{ mt: 4, mb: 4 }}>{content}</Container>
      </Box>


  );
}
